<script setup lang="ts">
import { formatMoney } from "~/utils/formatters"
import { PromoGiftProgressBarProps } from "./PromoGiftProgressBar.props"

const props = defineProps<PromoGiftProgressBarProps>()
const { t } = useI18n()

const progressStyle = computed(() => ({
  width: `${props.promoGiftData.progressPercent}%`
}))

const message = computed(() => {
  if (props.promoGiftData.isThresholdReached) {
    return t("cart.promoGift.reached")
  }
  return t("cart.promoGift.missingAmount", {
    amount: formatMoney(props.promoGiftData.missingAmountFloat)
  })
})
</script>

<template>
  <div class="cart-utils-promo-gift-progress-bar bg-grey-main rounded-lg p-4">
    <div
      v-if="promoGiftData.giftProduct"
      :class="[
        promoGiftData.giftProduct.imageUrl ? '' : 'mb-3',
        'flex',
        'items-center',
        'justify-between',
        'gap-3'
      ]"
    >
      <p class="mouse">
        <span class="mouse-medium">
          {{ $t("cart.promoGift.getProduct") }}
        </span>
        <span class="italic">
          {{ promoGiftData.giftProduct.productName }}
        </span>
      </p>
      <img
        v-if="promoGiftData.giftProduct.imageUrl"
        :src="promoGiftData.giftProduct.imageUrl"
        :alt="promoGiftData.giftProduct.productName"
        class="
          border-tiffany-main
          bg-white
          h-12
          w-12
          shrink-0
          rounded-full
          border
          object-contain
          p-1
        "
      />
    </div>
    <div class="mb-2 flex items-center gap-2">
      <UtilsIcon
        name="Gift.svg"
        color="tiffany-main"
        class="h-5 w-5 shrink-0"
      />
      <p class="mouse-bold" v-html="message" />
    </div>
    <div class="bg-tiffany-30 h-2 w-full overflow-hidden rounded-full">
      <div
        class="bg-tiffany-main h-full rounded-full transition-all duration-500"
        :style="progressStyle"
      />
    </div>
  </div>
</template>
